import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Countdown from "react-countdown";

import LoadingSpinner from "../../Components/Common/LoadingSpinner";

import "../../Styles/ConfirmPhoneNumber.css";

import Toast from "../../Utils/Toast";
import BackArrow from "../../Components/Common/BackArrow";
import { Transaction_Login } from "../../Connections/Transaction";

const ConfirmPhoneAmbassadors = ({ setToken }) => {
  const { state } = useLocation();
  const navigator = useNavigate();

  const firstInputRef = useRef(null);

  // ===========================================================

  const [code, setCode] = useState("");
  const [resendCodeTimer, setResendCodeTime] = useState(Date.now() + 120000);
  const [resendCodeLoading, setResendCodeLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  console.log(code);

  // ===========================================================

  const handleResentPhoneCode = () => {
    setResendCodeLoading(true);

    const form = new FormData();
    form.append("mobile", state?.phoneNumber);
    Transaction_Login.Login(form).then((res) => {
      setResendCodeLoading(false);
      setResendCodeTime(Date.now() + 120000);
      if (res[0] == true) {
        Toast("success", "کد تایید مجدد ارسال شد");
      } else {
        setLoading(false);
        Toast("error", res[1]);
      }
    });
  };

  const resendCodeTimerrenderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div
          className="ConfirmPhoneNumber_resend-code-wrapper"
          onClick={handleResentPhoneCode}
        >
          <div className="icon">
            <svg
              style={{ width: "100%" }}
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
            >
              <path
                d="M4.90481 5.11281H7.44756C7.67962 5.11281 7.90218 5.205 8.06628 5.36909C8.23037 5.53319 8.32256 5.75575 8.32256 5.98781C8.32256 6.21988 8.23037 6.44243 8.06628 6.60653C7.90218 6.77062 7.67962 6.86281 7.44756 6.86281H3.37006C3.13799 6.86281 2.91543 6.77062 2.75134 6.60653C2.58724 6.44243 2.49506 6.21988 2.49506 5.98781V1.91381C2.49506 1.68175 2.58724 1.45919 2.75134 1.29509C2.91543 1.131 3.13799 1.03881 3.37006 1.03881C3.60212 1.03881 3.82468 1.131 3.98878 1.29509C4.15287 1.45919 4.24506 1.68175 4.24506 1.91381V3.29631C5.7466 1.91636 7.61751 1.00353 9.62928 0.669313C11.6411 0.335098 13.7066 0.593962 15.5737 1.41429C17.4408 2.23462 19.0286 3.5809 20.1431 5.28872C21.2577 6.99654 21.8508 8.99197 21.8501 11.0313C21.8501 13.8158 20.744 16.4862 18.7753 18.4553C16.8065 20.4244 14.1363 21.5308 11.3518 21.5313C8.56703 21.5313 5.89632 20.4251 3.92719 18.4559C1.95805 16.4868 0.851807 13.8161 0.851807 11.0313H2.60181C2.60181 13.352 3.52368 15.5775 5.16462 17.2185C6.80557 18.8594 9.03116 19.7813 11.3518 19.7813C13.6725 19.7813 15.898 18.8594 17.539 17.2185C19.1799 15.5775 20.1018 13.352 20.1018 11.0313C20.1019 9.26889 19.5698 7.54751 18.5752 6.09257C17.5806 4.63764 16.1698 3.51697 14.5275 2.87732C12.8853 2.23767 11.0881 2.10885 9.37145 2.50774C7.65476 2.90662 6.09853 3.81461 4.90656 5.11281H4.90481Z"
                fill="white"
              />
            </svg>
          </div>
          <p>ارسال مجدد کد</p>
        </div>
      );
    } else {
      return (
        <span className="ConfirmPhoneNumber_resend-code-timer-wrapper number-font">
          {String(minutes).length == 1 ? `0${minutes}` : minutes}
          <span style={{ margin: "0 2px" }}>:</span>
          {String(seconds).length == 1 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };

  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ],
    fixNumbers = function (str) {
      if (typeof str === "string") {
        for (var i = 0; i < 10; i++) {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;
    };

  const handleSubmitConfirmPhoneNumberForm = (event) => {
    event.preventDefault();
    if (code.length == 5) {
      var codetemp = fixNumbers(code);
      setLoading(true);
      const form = new FormData();
      form.append("Mobile", state?.phoneNumber);
      form.append("ActiveCode", codetemp);
      Transaction_Login.ComfirmLogin(form).then((res) => {
        setLoading(false);
        if (res[0]) {
          setToken(res[2].data);
          Toast("success", "با موفقیت وارد شدی!");
          navigator("/account-safiran");
          window.location.reload();
        } else {
          setLoading(false);
          Toast("error", res[1]);
        }
      });
    } else {
      Toast("error", "کد را به درستی وارد نکرده‌اید");
    }
  };

  // ===========================================================

  useEffect(() => {
    if (!state) {
      navigator("/login", {
        replace: true,
      });
    }
  }, []);

  return (
    <div className="ConfirmPhoneNumber_page-wrapper">
      <div className="Login_wrapper-left-side login-ambassadors-img">
        <img
          className="Login_wrapper-left-side-image mobile-hidden"
          src="/imgs/Landing/Landing-first-section-banner.svg"
          alt="Desktop-login-banner"
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
        className="login_wrapper-top"
      >
        <img
          className="Login_wrapper-Top-side-image desktop-hidden"
          src="/imgs/Landing/Landing-first-section-banner.svg"
          alt="Mobile-login-banner"
          style={{ width: "85%", marginBottom: "400px" }}
        />
      </div>
      <div
        className="ConfirmPhoneNumber_wrapper-left-side-code"
        id="codepage-login"
      >
        <form
          onSubmit={handleSubmitConfirmPhoneNumberForm}
          className="ConfirmPhoneNumber_wrapper-right-side-code-containe"
        >
          <BackArrow link="/login-safiran" />
          <h3 className="ConfirmPhoneNumber_wrapper-right-side-container-title">
            ورود و ثبت‌نام
          </h3>
          <p className="ConfirmPhoneNumber_wrapper-right-side-code-container-tetx">
            کدی که به شماره
            <span className="number-font"> {state?.phoneNumber} </span>
            ارسال شده رو وارد کن{" "}
          </p>
          <div
            className="ConfirmPhoneNumber_wrapper-right-side-code-containe-stay-code"
            id="login-code"
          >
            <input
              style={{ width: "100%" }}
              className="ConfirmPhoneNumber_wrapper-right-side-code-containe-stay-code-input"
              type="number"
              value={code}
              onChange={(e) =>
                e.target.value.length < 6 ? setCode(e.target.value) : null
              }
            />
          </div>
          {error ? (
            <p className="ConfirmPhoneNumber_error-text text-red">
              کدی که نوشتی اشتباهه
            </p>
          ) : null}
          <div className="ConfirmPhoneNumber_wrapper-right-side-code-containe-footer">
            {resendCodeLoading ? (
              <LoadingSpinner color="rgb(15, 151, 255)" />
            ) : (
              <Countdown
                date={resendCodeTimer}
                renderer={resendCodeTimerrenderer}
              />
            )}
            <Link
              to={`/login-safiran`}
              className="ConfirmPhoneNumber_wrapper-right-side-code-containe-footer-left"
            >
              تغییر شماره موبایل
            </Link>
          </div>
          <button
            className="ConfirmPhoneNumber_wrapper-right-side-code-containe-button-Continuation"
            type="submit"
            disabled={code.length != 5}
          >
            {!loading ? <span>ادامه</span> : <LoadingSpinner />}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ConfirmPhoneAmbassadors;
